import { FormGroup, List, Text } from '@ksyos/design-system';
import { getSelectedLanguage } from '../../../../../translate';

export interface IDsmStoornisProps {
    dsmPrevalenteKlacht?: string;
    dsmToelichting?: string;
    dsmVermoeden?: string;
    init_dsmVermoeden?: string;
}

export function DsmStoornis(props: IDsmStoornisProps) {
    const { interapy, common } = getSelectedLanguage();
    const items: JSX.Element[] = [];

    if (props.dsmPrevalenteKlacht) {
        items.push(
            <Text
                fontWeight="bold"
                size="sm"
            >
                {interapy.dsmPrevalentComplaint}: {props.dsmPrevalenteKlacht}
            </Text>
        );
    }

    if (props.dsmVermoeden) {
        items.push(
            <Text
                fontWeight="bold"
                size="sm"
            >
                {`${interapy.dsmSuspicion}: ${props.dsmVermoeden}`}
            </Text>
        );
    }

    if (props.init_dsmVermoeden && props.dsmVermoeden && props.init_dsmVermoeden !== props.dsmVermoeden) {
        items.push(<>{`${interapy.dsmSuspicion}: ${props.dsmVermoeden}`}</>);
    }

    if (props.dsmToelichting) {
        items.push(<>{`${common.remarks}: ${props.dsmToelichting}`}</>);
    }

    return (
        <>
            {items.length > 0 && (
                <FormGroup label={interapy.dsmDisorder}>
                    <List size="small">
                        {items.map((item, index) => {
                            return <List.Item key={index}>{item}</List.Item>;
                        })}
                    </List>
                </FormGroup>
            )}
        </>
    );
}
